import React from "react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export function KpiCard({ label, value, icon: Icon, hint, accent = false, testId }) {
  return (
    <Card className="p-5 shadow-sm transition-shadow hover:shadow-md" data-testid={testId}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.05em] text-slate-500">{label}</p>
          <p className="mt-3 font-mono text-3xl font-bold tracking-tight text-slate-900" data-testid={`${testId}-value`}>
            {value}
          </p>
          {hint && <p className="mt-2 text-xs text-slate-400">{hint}</p>}
        </div>
        <div
          className={cn(
            "flex h-11 w-11 items-center justify-center rounded-lg",
            accent ? "bg-emerald-600 text-white" : "bg-emerald-50 text-emerald-600"
          )}
        >
          <Icon className="h-5 w-5" />
        </div>
      </div>
    </Card>
  );
}
